import React, { useState } from 'react';
import axios from 'axios';
import { FiLock } from 'react-icons/fi';
import { API_URL, API_BASE_URL } from '../config';

// Last-4-of-phone gate shown before a portal or hub reveals anything. On success it hands the
// signed access token back up so the parent can store it and re-fetch.
export default function PortalAccessGate({ company, verifyPath, subtitle, onVerified }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (code.replace(/\D/g, '').length < 4) { setError('Please enter 4 digits.'); return; }
    setBusy(true); setError('');
    try {
      const res = await axios.post(`${API_URL}${verifyPath}`, { code });
      onVerified(res.data.access_token);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not verify. Please try again.');
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ backgroundColor: 'white', borderRadius: 16, padding: 32, maxWidth: 400, width: '100%', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', textAlign: 'center' }}>
        {company?.logo && (
          <img src={`${API_BASE_URL}${company.logo}`} alt="Logo" style={{ height: 44, marginBottom: 12 }} onError={(e) => (e.target.style.display = 'none')} />
        )}
        <div style={{ fontSize: 18, fontWeight: 700, color: '#111827' }}>{company?.name || 'Client Portal'}</div>
        {subtitle && <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>{subtitle}</div>}

        <div style={{ margin: '22px 0 8px', display: 'flex', justifyContent: 'center' }}>
          <div style={{ background: '#eff6ff', color: '#2563eb', borderRadius: '50%', width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <FiLock size={22} />
          </div>
        </div>
        <div style={{ fontSize: 14, color: '#374151', marginBottom: 16 }}>
          For your privacy, enter the <strong>last 4 digits</strong> of the phone number on file for this project.
        </div>

        <form onSubmit={submit}>
          <input
            type="tel"
            inputMode="numeric"
            maxLength={4}
            autoFocus
            value={code}
            onChange={(e) => { setCode(e.target.value.replace(/\D/g, '')); setError(''); }}
            placeholder="••••"
            style={{ width: 140, textAlign: 'center', fontSize: 24, letterSpacing: 8, padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 10, marginBottom: 12 }}
          />
          {error && <div style={{ color: '#dc2626', fontSize: 13, marginBottom: 12 }}>{error}</div>}
          <div>
            <button type="submit" disabled={busy}
              style={{ padding: '12px 28px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 10, fontWeight: 600, fontSize: 15, cursor: busy ? 'wait' : 'pointer' }}>
              {busy ? 'Checking…' : 'View Project'}
            </button>
          </div>
        </form>
        {company?.phone && (
          <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 18 }}>
            Trouble getting in? Call us at {company.phone}.
          </div>
        )}
      </div>
    </div>
  );
}
